module.exports = __webpack_public_path__ + "images/emoji/bridge_at_night.daf4999eacdcbeb965ad.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/bridge_at_night.png
// module id = yje2
// module chunks = 13